<template>
  <div>
    <div class="neutral--text text--tone-400 text-label-m mb-4">
      {{ label }}
    </div>
    <v-radio-group
      v-bind="$attrs"
      v-on="$listeners"
      row
      hide-details
      dense
      class="ml-4"
    >
      <v-radio
        v-for="radioItem in radioList"
        :key="radioItem.value"
        :value="radioItem.value"
        :label="radioItem.label"
        :color="color"
        on-icon="$RadioChecked"
        off-icon="$RadioUnchecked"
        :ripple="false"
      />
    </v-radio-group>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'BaseRadioGroup',
  props: {
    radioList: {
      type: Array,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      default: 'primary',
    },
  },
});
</script>

<style lang="scss" scoped>
.v-input--selection-controls {
  margin-top: 0px;
  padding-top: 0px;
}
</style>
